:root {
  --color-pageBackground: var(--palette-navy100);
  --color-pageBackgroundModalActive: var(--palette-navy200);
  --color-pageBackgroundTopLeft: var(--palette-navy100);
  --color-pageBackgroundBottomRight: var(--palette-blue150);
  --color-pageBackgroundLineTop: var(--palette-white);
  --color-pageBackgroundLineMid: var(--palette-navy100);
  --color-pageBackgroundLineBottom: var(--palette-blue150);
  --color-pageText: #272630;
  --color-pageTextLight: var(--palette-navy500);
  --color-pageTextSubdued: var(--palette-navy300);
  --color-pageTextDark: var(--palette-navy800);
  --color-pageTextPositive: var(--palette-purple600);
  --color-pageTextLink: var(--palette-blue600);
  --color-pageTextLinkLight: var(--palette-blue300);

  --color-cardBackground: var(--palette-white);
  --color-cardBorder: var(--palette-purple700);
  --color-cardShadow: var(--palette-navy700);

  --color-tableBackground: var(--palette-white);
  --color-tableRowBackgroundAlternate: var(--color-tableBackground);
  --color-tableRowBackgroundHover: var(--palette-navy50);
  --color-tableText: var(--color-pageText);
  --color-tableTextItemAdded: var(--color-tableText);
  --color-tableTextLight: var(--palette-navy400);
  --color-tableTextSubdued: var(--palette-navy100);
  --color-tableTextSelected: var(--palette-navy700);
  --color-tableTextHover: var(--palette-navy900);
  --color-tableTextInactive: var(--palette-navy500);
  --color-tableHeaderText: var(--palette-navy600);
  --color-tableHeaderBackground: var(--palette-white);
  --color-tableBorder: var(--palette-navy100);
  --color-tableBorderSelected: var(--palette-purple500);
  --color-tableBorderHover: var(--palette-purple400);
  --color-tableBorderSeparator: var(--palette-navy400);
  --color-tableRowBackgroundHighlight: var(--palette-blue150);
  --color-tableRowBackgroundHighlightText: var(--palette-navy700);
  --color-tableRowHeaderBackground: var(--palette-navy50);
  --color-tableRowHeaderText: var(--palette-navy800);

  --color-numberPositive: var(--palette-green700);
  --color-numberNegative: var(--palette-red500);
  --color-numberNeutral: var(--palette-navy100);
  --color-budgetNumberNegative: var(--color-numberNegative);
  --color-budgetNumberZero: var(--color-tableTextSubdued);
  --color-budgetNumberNeutral: var(--color-tableText);
  --color-budgetNumberPositive: var(--color-budgetNumberNeutral);
  --color-templateNumberFunded: var(--color-numberPositive);
  --color-templateNumberUnderFunded: var(--palette-orange700);
  --color-toBudgetPositive: var(--color-numberPositive);
  --color-toBudgetZero: var(--color-numberPositive);
  --color-toBudgetNegative: var(--color-budgetNumberNegative);

  --color-sidebarBackground: var(--palette-navy900);
  --color-sidebarItemBackgroundPending: var(--palette-orange200);
  --color-sidebarItemBackgroundPositive: var(--palette-green500);
  --color-sidebarItemBackgroundFailed: var(--palette-red300);
  --color-sidebarItemBackgroundHover: var(--palette-navy800);
  --color-sidebarItemAccentSelected: var(--palette-purple200);
  --color-sidebarItemBackgroundSelected: color-mix(
    in srgb,
    var(--color-sidebarItemAccentSelected) 22%,
    transparent
  );
  --color-sidebarItemText: var(--palette-navy150);
  --color-sidebarItemTextUpdated: var(--color-sidebarItemText);
  --color-sidebarItemTextSelected: var(--palette-purple200);
  --color-sidebarBudgetName: var(--palette-navy150);
  --color-sidebarHeaderText: var(--palette-white);
  --color-sidebarTextSubdued: var(--palette-navy300);
  --color-sidebarTextMuted: var(--palette-navy500);
  --color-sidebarTextPositive: var(--color-sidebarItemBackgroundPositive);
  --color-sidebarTextFailed: var(--color-sidebarItemBackgroundFailed);
  --color-sidebarBackgroundFailedSubtle: color-mix(
    in srgb,
    var(--color-sidebarItemBackgroundFailed) 16%,
    transparent
  );
  --color-sidebarBorder: var(--color-sidebarItemBackgroundHover);
  --color-sidebarControlBackground: var(--color-sidebarItemBackgroundHover);
  --color-sidebarBrand: var(--color-sidebarItemAccentSelected);

  --color-settingsCardBackground: var(--color-tableBackground);
  --color-settingsCardBorder: var(--color-tableBorder);
  --color-settingsCardText: var(--color-tableText);
  --color-settingsCardTextSubdued: var(--palette-navy600);
  --color-settingsNavItemText: var(--color-pageText);
  --color-settingsNavItemBackgroundHover: color-mix(
    in srgb,
    var(--color-settingsNavItemText) 8%,
    transparent
  );
  --color-settingsNavItemAccentSelected: var(--palette-purple500);
  --color-settingsNavItemTextSelected: var(--palette-purple600);
  --color-settingsNavItemBackgroundSelected: color-mix(
    in srgb,
    var(--color-settingsNavItemAccentSelected) 10%,
    transparent
  );

  --color-menuBackground: var(--palette-white);
  --color-menuItemBackground: var(--palette-navy50);
  --color-menuItemBackgroundHover: var(--palette-navy100);
  --color-menuItemText: var(--palette-navy900);
  --color-menuItemTextHover: var(--color-menuItemText);
  --color-menuItemTextSelected: var(--palette-purple300);
  --color-menuItemTextHeader: var(--palette-navy400);
  --color-menuBorder: var(--palette-navy100);
  --color-menuBorderHover: var(--palette-purple100);
  --color-menuKeybindingText: var(--palette-navy400);
  --color-menuAutoCompleteBackground: var(--palette-navy900);
  --color-menuAutoCompleteBackgroundHover: var(--palette-navy600);
  --color-menuAutoCompleteText: var(--palette-white);
  --color-menuAutoCompleteTextHover: var(--palette-green150);
  --color-menuAutoCompleteTextHeader: var(--palette-orange150);
  --color-menuAutoCompleteItemTextHover: var(--color-menuAutoCompleteText);
  --color-menuAutoCompleteItemText: var(--color-menuAutoCompleteText);

  --color-modalBackground: var(--palette-white);
  --color-modalBorder: var(--palette-white);
  --color-mobileHeaderBackground: var(--palette-purple400);
  --color-mobileHeaderText: var(--palette-navy50);
  --color-mobileHeaderTextSubdued: var(--palette-gray200);
  --color-mobileHeaderTextHover: rgba(200, 200, 200, 0.15);
  --color-mobilePageBackground: var(--palette-navy50);
  --color-mobileNavBackground: var(--palette-white);
  --color-mobileNavItem: var(--palette-gray300);
  --color-mobileNavItemSelected: var(--palette-purple500);
  --color-mobileAccountShadow: var(--palette-navy300);
  --color-mobileAccountText: var(--palette-blue800);
  --color-mobileTransactionSelected: var(--palette-purple500);

  --color-mobileViewTheme: var(--color-mobileHeaderBackground);
  --color-mobileConfigServerViewTheme: var(--palette-purple500);

  --color-markdownNormal: var(--palette-purple150);
  --color-markdownDark: var(--palette-purple400);
  --color-markdownLight: var(--palette-purple100);

  --color-buttonMenuText: var(--palette-navy100);
  --color-buttonMenuTextHover: var(--palette-navy50);
  --color-buttonMenuBackground: transparent;
  --color-buttonMenuBackgroundHover: rgba(200, 200, 200, 0.25);
  --color-buttonMenuBorder: var(--palette-navy500);
  --color-buttonMenuSelectedText: var(--palette-green800);
  --color-buttonMenuSelectedTextHover: var(--palette-orange800);
  --color-buttonMenuSelectedBackground: var(--palette-orange200);
  --color-buttonMenuSelectedBackgroundHover: var(--palette-orange300);
  --color-buttonMenuSelectedBorder: var(--color-buttonMenuSelectedBackground);

  --color-buttonPrimaryText: var(--palette-white);
  --color-buttonPrimaryTextHover: var(--color-buttonPrimaryText);
  --color-buttonPrimaryBackground: var(--palette-purple500);
  --color-buttonPrimaryBackgroundHover: var(--palette-purple300);
  --color-buttonPrimaryBorder: var(--color-buttonPrimaryBackground);
  --color-buttonPrimaryShadow: rgba(0, 0, 0, 0.3);
  --color-buttonPrimaryDisabledText: var(--palette-white);
  --color-buttonPrimaryDisabledBackground: var(--palette-navy300);
  --color-buttonPrimaryDisabledBorder: var(
    --color-buttonPrimaryDisabledBackground
  );

  --color-buttonNormalText: var(--palette-navy900);
  --color-buttonNormalTextHover: var(--color-buttonNormalText);
  --color-buttonNormalBackground: var(--palette-white);
  --color-buttonNormalBackgroundHover: var(--color-buttonNormalBackground);
  --color-buttonNormalBorder: var(--palette-navy150);
  --color-buttonNormalShadow: rgba(0, 0, 0, 0.2);
  --color-buttonNormalSelectedText: var(--palette-white);
  --color-buttonNormalSelectedBackground: var(--palette-blue600);
  --color-buttonNormalDisabledText: var(--palette-navy300);
  --color-buttonNormalDisabledBackground: var(--color-buttonNormalBackground);
  --color-buttonNormalDisabledBorder: var(--color-buttonNormalBorder);

  --color-calendarText: var(--palette-navy50);
  --color-calendarBackground: var(--palette-navy900);
  --color-calendarItemText: var(--palette-navy150);
  --color-calendarItemBackground: var(--palette-navy800);
  --color-calendarSelectedBackground: var(--palette-navy500);
  --color-datePickerRangeBackground: var(--palette-purple150);

  --color-buttonBareText: var(--color-pageText);
  --color-buttonBareTextHover: var(--color-pageText);
  --color-buttonBareDisabledText: var(--color-pageTextSubdued);
  --color-buttonBareBackground: transparent;
  --color-buttonBareDisabledBackground: var(--color-buttonBareBackground);
  --color-buttonBareBackgroundHover: rgba(100, 100, 100, 0.15);
  --color-buttonBareBackgroundActive: rgba(100, 100, 100, 0.25);

  --color-noticeBackground: var(--palette-green150);
  --color-noticeBackgroundLight: var(--palette-green100);
  --color-noticeBackgroundDark: var(--palette-green500);
  --color-noticeText: var(--palette-green700);
  --color-noticeTextLight: var(--palette-green500);
  --color-noticeTextDark: var(--palette-green900);
  --color-noticeTextMenu: var(--palette-green200);
  --color-noticeBorder: var(--palette-green500);
  --color-warningBackground: var(--palette-orange200);
  --color-warningText: var(--palette-orange700);
  --color-warningTextLight: var(--palette-orange500);
  --color-warningTextDark: var(--palette-orange900);
  --color-warningBorder: var(--palette-orange500);
  --color-errorBackground: var(--palette-red100);
  --color-errorText: var(--palette-red500);
  --color-errorTextDark: var(--palette-red700);
  --color-errorTextDarker: var(--palette-red900);
  --color-errorTextMenu: var(--palette-red200);
  --color-errorBorder: var(--palette-red500);
  --color-upcomingBackground: var(--palette-purple100);
  --color-upcomingText: var(--palette-purple700);
  --color-upcomingBorder: var(--palette-purple500);

  --color-formLabelText: var(--palette-blue600);
  --color-formLabelBackground: var(--palette-blue200);
  --color-formInputBackground: var(--palette-navy50);
  --color-formInputBackgroundSelected: var(--palette-white);
  --color-formInputBackgroundSelection: var(--palette-purple500);
  --color-formInputBorder: var(--palette-navy150);
  --color-formInputTextReadOnlySelection: var(--palette-navy50);
  --color-formInputBorderSelected: var(--palette-purple500);
  --color-formInputText: var(--palette-navy900);
  --color-formInputTextSelected: var(--palette-navy50);
  --color-formInputTextPlaceholder: var(--palette-navy300);
  --color-formInputTextPlaceholderSelected: var(--palette-navy200);
  --color-formInputTextSelection: var(--palette-navy100);
  --color-formInputShadowSelected: var(--palette-purple300);
  --color-formInputTextHighlight: var(--palette-purple200);
  --color-checkboxText: var(--color-tableBackground);
  --color-checkboxBackgroundSelected: var(--palette-blue500);
  --color-checkboxBorderSelected: var(--palette-blue500);
  --color-checkboxShadowSelected: var(--palette-blue300);
  --color-checkboxToggleBackground: var(--palette-gray400);
  --color-checkboxToggleBackgroundSelected: var(--palette-purple600);
  --color-checkboxToggleDisabled: var(--palette-gray200);

  --color-pillBackground: var(--palette-navy150);
  --color-pillBackgroundLight: var(--palette-navy50);
  --color-pillText: var(--palette-navy800);
  --color-pillTextHighlighted: var(--palette-purple600);
  --color-pillBorder: var(--palette-navy150);
  --color-pillBorderDark: var(--palette-navy300);
  --color-pillBackgroundSelected: var(--palette-blue150);
  --color-pillTextSelected: var(--palette-blue900);
  --color-pillBorderSelected: var(--palette-purple500);
  --color-pillTextSubdued: var(--palette-navy200);

  --color-reportsRed: var(--palette-red300);
  --color-reportsBlue: var(--palette-blue400);
  --color-reportsGreen: var(--palette-green400);
  --color-reportsGray: var(--palette-gray400);
  --color-reportsLabel: var(--palette-navy900);
  --color-reportsInnerLabel: var(--palette-navy800);
  --color-reportsNumberPositive: var(--color-numberPositive);
  --color-reportsNumberNegative: var(--color-numberNegative);
  --color-reportsNumberNeutral: var(--color-numberNeutral);
  --color-reportsChartFill: var(--color-reportsNumberPositive);

  --color-noteTagBackground: var(--palette-purple125);
  --color-noteTagBackgroundHover: var(--palette-purple150);
  --color-noteTagDefault: var(--palette-purple125);
  --color-noteTagText: var(--palette-black);

  --color-budgetCurrentMonth: var(--color-tableBackground);
  --color-budgetOtherMonth: var(--palette-gray50);
  --color-budgetHeaderCurrentMonth: var(--color-budgetOtherMonth);
  --color-budgetHeaderOtherMonth: var(--palette-gray80);

  --color-floatingActionBarBackground: var(--palette-purple400);
  --color-floatingActionBarBorder: var(--color-floatingActionBarBackground);
  --color-floatingActionBarText: var(--palette-navy50);

  --color-tooltipText: var(--palette-navy900);
  --color-tooltipBackground: var(--palette-white);
  --color-tooltipBorder: var(--palette-navy150);

  --color-calendarCellBackground: var(--palette-navy100);

  --color-overlayBackground: rgba(0, 0, 0, 0.3);

  --color-chartQual1: var(--palette-chartQual1);
  --color-chartQual2: var(--palette-chartQual2);
  --color-chartQual3: var(--palette-chartQual3);
  --color-chartQual4: var(--palette-chartQual4);
  --color-chartQual5: var(--palette-chartQual5);
  --color-chartQual6: var(--palette-chartQual6);
  --color-chartQual7: var(--palette-chartQual7);
  --color-chartQual8: var(--palette-chartQual8);
  --color-chartQual9: var(--palette-chartQual9);
}
